import * as BBApi from '.';
const rootUrl: string = BBApi.host + '/word-tracks';

export async function getMessages(): Promise<Record<string, any>[]> {
	const target: string = window.location.hash;

	const url: URL = new URL(rootUrl + '/messages');
	if (target !== '') url.searchParams.append('target', target.replace('#', ''));

	const response: Response = await BBApi.get(url.href);
	const messages: Record<string, any>[] = await response.json();
	return messages;
}

export async function approveMessage(id: number): Promise<void> {
	const target: string = window.location.hash;
	const url: URL = new URL(rootUrl + `/messages/${id}`);
	if (target !== '') url.searchParams.append('target', target.replace('#', ''));

	const response: Response = await BBApi.put(url.href, { checked: true });

	if (response.ok === false) {
		throw new Error('Word tracked message not updated');
	}
}

export async function approveUserMessages(userId: number): Promise<void> {
	const target: string = window.location.hash;
	const url: URL = new URL(rootUrl + `/messages/user/${userId}`);
	if (target !== '') url.searchParams.append('target', target.replace('#', ''));

	const response: Response = await BBApi.put(url.href, { checked: true });

	if (response.ok === false) {
		throw new Error('Word tracked messages not updated');
	}
}

export async function getWords(): Promise<Record<string, any>[]> {
	const target: string = window.location.hash;

	const url: URL = new URL(rootUrl + '/words');
	if (target !== '') url.searchParams.append('target', target.replace('#', ''));

	const response: Response = await BBApi.get(url.href);
	const words: Record<string, any>[] = await response.json();
	return words;
}

export async function createWord(word: Record<string, any>): Promise<any> {
	const target: string = window.location.hash;
	const url: URL = new URL(rootUrl + '/words');
	if (target !== '') url.searchParams.append('target', target.replace('#', ''));

	const response: Response = await BBApi.post(url.href, word);

	if (response.ok === false) {
		throw new Error('Word tracked word not created');
	}
}

export async function updateWord(id: number, word: Record<string, any>): Promise<void> {
	const target: string = window.location.hash;
	const url: URL = new URL(rootUrl + `/words/${id}`);
	if (target !== '') url.searchParams.append('target', target.replace('#', ''));

	const response: Response = await BBApi.put(url.href, word);

	if (response.ok === false) {
		throw new Error('Word tracked word not updated');
	}
}

export async function removeWord(id: number): Promise<void> {
	const target: string = window.location.hash;
	const url: URL = new URL(rootUrl + `/words/${id}`);
	if (target !== '') url.searchParams.append('target', target.replace('#', ''));

	const response: Response = await BBApi.del(url.href);

	if (response.ok === false) {
		throw new Error('Word tracked word not removed');
	}
}
